// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"98":"97a8e1ffe02d33f1","216":"6f534c71ab8fd897","2013":"03699dc661ae7a4a","3807":"4173bbc63bb2105a"}[chunkId] + ".js";
};